var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    "data-name": "Group 1776"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#f5f7f8",
    "data-name": "Ellipse 48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.235 11.239a.079.079 0 0 0-.1-.118 6.755 6.755 0 0 1-1.629.407 3.278 3.278 0 0 0 1.367-1.6.077.077 0 0 0-.112-.093 6.531 6.531 0 0 1-1.847.68.08.08 0 0 1-.074-.024 3.257 3.257 0 0 0-5.555 2.9.081.081 0 0 1-.083.1 9.262 9.262 0 0 1-3.614-.983 9.247 9.247 0 0 1-2.916-2.336.078.078 0 0 0-.129.012 3.3 3.3 0 0 0-.381 1.541 3.243 3.243 0 0 0 1.445 2.706 3.223 3.223 0 0 1-1.358-.341.08.08 0 0 0-.117.072 3.353 3.353 0 0 0 .741 1.957 3.259 3.259 0 0 0 1.878 1.12 3.127 3.127 0 0 1-.874.135 3.9 3.9 0 0 1-.482-.036.079.079 0 0 0-.087.1 3.265 3.265 0 0 0 3 2.129 6.538 6.538 0 0 1-4.021 1.4q-.225 0-.449-.015a.081.081 0 0 0-.05.149 9.205 9.205 0 0 0 4.7 1.285 9.2 9.2 0 0 0 9.309-9.264v-.381a.08.08 0 0 1 .032-.064 6.692 6.692 0 0 0 1.406-1.438",
    "data-name": "Path 2162"
  })));
};
export default SvgTwitter;